import { render } from "./MenuRight.vue?vue&type=template&id=3c68a88a"
import script from "./MenuRight.vue?vue&type=script&lang=js"
export * from "./MenuRight.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__